import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";

import {
  Checkbox,
  FormControlLabel,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Button,
  Typography,
  Paper,
} from "@mui/material";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { api } from "@api/api";
import axios from "axios";

const ModalidadeSelect = forwardRef(
  ({ onFileChange, onModalidadeChange, modalidade, onDataChange }, ref) => {
    const [modalidades, setModalidades] = useState([]);
    const [modalidadeSelecionada, setModalidadeSelecionada] = useState("");
    const [anosSelecionados, setAnosSelecionados] = useState([]);
    const [file, setFile] = useState(null);
    const [ensinoInfantil, setEnsinoInfantil] = useState(false);

    useEffect(() => {
      const fetchModalidades = async () => {
        try {
          const response = await axios.get(api.listModalities(), {
            withCredentials: true,
          });

          setModalidades(response.data);
        } catch (error) {
          console.error("Erro ao buscar modalidades:", error);
        }
      };

      fetchModalidades();
    }, []);

    useImperativeHandle(ref, () => ({
      limparCamposInternos: () => {
        setModalidadeSelecionada("");
        setAnosSelecionados([]);
        setFile(null);
        setEnsinoInfantil(false);
      },
    }));

    const handleModalidadeChange = (event) => {
      const modalidadeId = event.target.value;

      setModalidadeSelecionada(modalidadeId);

      const modalidadeEscolhida = modalidades.find(
        (mod) => mod.id === modalidadeId,
      );

      if (modalidadeEscolhida) {
        onModalidadeChange(modalidadeEscolhida.nome);

        setEnsinoInfantil(modalidadeEscolhida.ensino_infantil || false);
      } else {
        onModalidadeChange("");
        setEnsinoInfantil(false);
      }

      setAnosSelecionados([]);
    };

    const handleCheckboxChange = (event) => {
      const { value, checked } = event.target;
      const anoNumero = Number(value);

      setAnosSelecionados((prev) => {
        const novosAnos = checked
          ? [...prev, { numero: anoNumero, selecionado: true }]
          : prev.filter((ano) => ano.numero !== anoNumero);

        onDataChange({
          modalidade,
          anosSelecionados: novosAnos,
        });

        return novosAnos;
      });
    };

    const handleFileChange = (event) => {
      const selectedFile = event.target.files[0];

      setFile(selectedFile);

      if (onFileChange) {
        onFileChange(selectedFile);
      }
    };

    return (
      <div>
        <Paper elevation={3} sx={{ padding: 3, borderRadius: 2, marginTop: 3 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#1976d2" }}
          >
            Modalidade
          </Typography>

          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Modalidade</InputLabel>

                <Select
                  value={modalidadeSelecionada}
                  onChange={handleModalidadeChange}
                  label="Modalidade"
                  variant="outlined"
                  sx={{
                    backgroundColor: "#f5f5f5",
                    borderRadius: 1,
                  }}
                >
                  {modalidades.map((modalidade) => (
                    <MenuItem key={modalidade.id} value={modalidade.id}>
                      {modalidade.nome}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {ensinoInfantil && (
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-start"
                  alignItems="center"
                >
                  {[0, 1, 2, 3, 4, 5].map((ano) => (
                    <Grid item xs={2} key={ano}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            value={ano}
                            checked={anosSelecionados.some(
                              (anoObj) =>
                                anoObj.numero === ano && anoObj.selecionado,
                            )}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label={ano}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            )}

            <Grid item xs={12}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#1976d2" }}
              >
                Anexe um comprovante de mantença:
              </Typography>

              <Button
                variant="contained"
                component="label"
                startIcon={<CloudUploadIcon />}
                sx={{
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#1565c0" },
                }}
              >
                Anexar Documento
                <input
                  type="file"
                  hidden
                  onChange={handleFileChange}
                  accept="application/pdf"
                />
              </Button>

              {file && (
                <Grid container spacing={1} sx={{ marginTop: 1 }}>
                  <Grid item xs={12}>
                    <Typography variant="body2" color="textSecondary">
                      Documento anexado: {file.name}
                    </Typography>

                    <Typography variant="body2" color="textSecondary">
                      Tamanho: {(file.size / 1024).toFixed(2)} KB
                    </Typography>

                    <Typography variant="body2" color="textSecondary">
                      Tipo: {file.type}
                    </Typography>
                  </Grid>
                </Grid>
              )}

              {!file && (
                <>
                  <Typography
                    variant="body2"
                    sx={{ marginTop: 2, color: "red" }}
                  >
                    Este documento é utilizado para comprovar a mantença e
                    autorizar o cadastro.
                  </Typography>

                  <Typography variant="body2" sx={{ color: "red" }}>
                    Recomenda-se utilizar os atos autorizativos para este fim.
                    (Anexar apenas PDF)
                  </Typography>
                </>
              )}
            </Grid>
          </Grid>
        </Paper>
      </div>
    );
  },
);

export default ModalidadeSelect;
